var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextItemWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 11.53 30.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#f4f3f4;}.cls-4{clip-path:url(#clippath-1);}.cls-5{clip-path:url(#clippath-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 11.53,
    height: 30.67
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 11.53,
    height: 30.67
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 11.53,
    height: 30.67
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m.24,0H.24l3.83,3.19s.05.06.05.1v14.51c0,.11-.13.17-.22.1L.29,14.9s-.05-.06-.05-.1v-2.24c0-.11.13-.18.22-.1l1.59,1.33c.13.11.3-.07.18-.19l-1.96-2.16s-.03-.06-.03-.09v-1.74c0-.11.13-.17.22-.1l1.59,1.33c.13.11.3-.07.18-.19l-1.96-2.16s-.03-.06-.03-.09v-1.74c0-.11.13-.17.22-.1l1.59,1.33c.13.11.3-.07.18-.19L.28,5.51s-.03-.06-.03-.09v-1.74c0-.11.13-.18.22-.1l1.59,1.33c.13.11.3-.07.18-.19L.28,2.55s-.03-.06-.03-.09V0ZM11.29,0l-3.83,3.19s-.05.06-.05.1v14.52c0,.11.13.17.22.1l3.61-3.01s.05-.06.05-.1v-2.24c0-.11-.13-.18-.22-.1l-1.59,1.33c-.13.11-.3-.07-.18-.19l1.96-2.16s.03-.06.03-.09v-1.74c0-.11-.13-.17-.22-.1l-1.59,1.33c-.13.11-.3-.07-.18-.19l1.96-2.16s.03-.06.03-.09v-1.74c0-.11-.13-.17-.22-.1l-1.59,1.33c-.13.11-.3-.07-.18-.19l1.96-2.16s.03-.06.03-.09v-1.74c0-.11-.13-.18-.22-.1l-1.59,1.33c-.13.11-.3-.07-.18-.19l1.96-2.16s.03-.06.03-.09V0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m5.76,30.67h0s0,0,0,0l4.59-4.59c.76-.76,1.16-1.64,1.17-2.55v-.02c0-.82-.32-1.59-.9-2.19-.58-.6-1.35-.94-2.17-.96-.91-.03-1.79.34-2.56,1.07l-.05.05c-.05.05-.13.05-.18,0l-.05-.05c-.76-.72-1.65-1.09-2.56-1.07-.82.02-1.59.36-2.17.96-.58.6-.9,1.37-.9,2.19v.02c0,.91.41,1.8,1.17,2.55l4.59,4.59h0s0,0,0,0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m5.76,20.61h0s0,0,0,0c.32-.32.65-.56.98-.73V3.95c0-.54-.44-.98-.98-.98s-.98.44-.98.98v15.92c.33.17.66.41.98.73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextItemWhite);
export default __webpack_public_path__ + "static/media/next-item-white.a495bbdac1b61f76b8632980a0cc3028.svg";
export { ForwardRef as ReactComponent };